export class HTTP {
  static REQUEST_TIMEOUT_MS = 10000

  // The server sometimes returns a non-JSON body on error (an HTML error page from
  // Rails or a proxy in front of it). JSON.parse-ing that blindly throws
  // "Unrecognized token '<'" and hides the real status/response from error reporting.
  static parseJSON(responseText) {
    if (!responseText) { return null }
    try {
      return JSON.parse(responseText)
    } catch (e) {
      return null
    }
  }

  static resolveBody(xhr, resolve, reject) {
    const body = HTTP.parseJSON(xhr.responseText)
    if (body === null && xhr.responseText) {
      reject({ message: `Unexpected response from server (status ${xhr.status})`, status: xhr.status })
    } else {
      resolve(body)
    }
  }

  static rejectBody(xhr, reject) {
    reject(
      HTTP.parseJSON(xhr.responseText) ||
      { message: `Request failed with status ${xhr.status}`, status: xhr.status }
    )
  }

  // A connection failure (server down, DNS failure, no network) or a request that
  // never gets a response neither loads nor errors on its own, so xhr.onload alone
  // leaves the promise hanging forever. These are tagged with networkError so callers
  // can tell them apart from an ordinary HTTP error status.
  static attachFailureHandlers(xhr, reject) {
    xhr.timeout = HTTP.REQUEST_TIMEOUT_MS
    xhr.onerror = function() {
      reject({ message: "Unable to reach the server. Please check your connection and try again.", networkError: true })
    }
    xhr.ontimeout = function() {
      reject({ message: "The server took too long to respond. Please try again.", networkError: true })
    }
  }

  static handleResponse(status, success, failure) {
    if (status >= 200 && status < 300) {
      success()
    } else if (
      (status >= 300 && status < 400) ||
      status == 401 ||
      status == 403
    ) {
      window.location.href = "/users/sign_in?return_to=/app/"
    } else {
      failure()
    }
  }

  static get(url) {
    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest()
      xhr.open("GET", url, true)
      HTTP.attachFailureHandlers(xhr, reject)
      xhr.onload = function() {
        var status = xhr.status
        HTTP.handleResponse(
          status,
          () => { HTTP.resolveBody(xhr, resolve, reject) },
          () => { HTTP.rejectBody(xhr, reject) }
        )
      }
      xhr.send()
    })
  }

  static post(url, message) {
    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest()
      xhr.open("POST", url, true)
      xhr.setRequestHeader("Content-Type", "application/json")
      HTTP.attachFailureHandlers(xhr, reject)

      xhr.onload = function() {
        let status = xhr.status

        HTTP.handleResponse(
          status,
          () => { HTTP.resolveBody(xhr, resolve, reject) },
          () => { HTTP.rejectBody(xhr, reject) }
        )
      }

      xhr.send(JSON.stringify(message))
    })
  }

  static delete(url, message) {
    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest()
      xhr.open("DELETE", url, true)
      xhr.setRequestHeader("Content-Type", "application/json")
      HTTP.attachFailureHandlers(xhr, reject)

      xhr.onload = function() {
        let status = xhr.status

        HTTP.handleResponse(
          status,
          () => { HTTP.resolveBody(xhr, resolve, reject) },
          () => { HTTP.rejectBody(xhr, reject) }
        )
      }

      xhr.send()
    })
  }

  static put(url, message) {
    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest()
      xhr.open("PUT", url, true)
      xhr.setRequestHeader("Content-Type", "application/json")
      HTTP.attachFailureHandlers(xhr, reject)

      xhr.onload = function() {
        let status = xhr.status
        HTTP.handleResponse(
          status,
          () => { HTTP.resolveBody(xhr, resolve, reject) },
          () => { HTTP.rejectBody(xhr, reject) }
        )
      }

      xhr.send(JSON.stringify(message))
    })
  }
}
